export const PILOT_COMPONENTS_TABLE_FRENCH_LOCALE = {
  globalSearchPlaceholder: "Rechercher une valeur...",
  headers: {
    brand: "Marque",
    description: "Description",
    note: "Note",
    serial: "Numéro de série",
  },
  empty: "Aucun composant trouvé...",
};
